var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"500px","border":"none"},attrs:{"src":_vm.pdfsrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }